import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Nav, Navbar} from 'react-bootstrap';
// import { Link } from "react-router-dom";

export default class Menu extends Component {
	render() {
		return (
			<Navbar expand="lg">
				<Container>
					<Nav.Link href="/" className="text-light mx-2 text-light navbar-brand">MEHEDI</Nav.Link>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav">
						<Nav className="mx-auto">
							<Nav.Link href="/" className="text-light mx-2">Home</Nav.Link>
							<Nav.Link href="/about" className="text-light mx-2">About</Nav.Link>
							<Nav.Link href="/blog" className="text-light mx-2">Blog</Nav.Link>
							<Nav.Link href="#link" className="text-light mx-2">Client</Nav.Link>
							<Nav.Link href="#link" className="text-light mx-2">Services</Nav.Link>
							<Nav.Link href="#link" className="text-light mx-2">Contact</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		)
	}
}
